import service from "./service";
import endpoint from "./constantUrl";

// Trade
export const getTradesByEvent = (param) => {
  return service.post(`${endpoint.MARLIN_URL}/v1/trades/list-by-event`, param);
};
